module.exports = __webpack_public_path__ + "static/assets/2de90b55229f38c202115f7febd08f8b.png";